<template>
  <div class="user-container">
    <div class="avatar-container">
      <img 
        class="discord-avatar"
        :src="getImage()"
        @error="useDefaultImage"
      />
    </div>
    <div class="user-info-container">
      <div class="discord-tag">
        <span class="discord-tag-text">
          {{ discord.username + '#' + discord.discriminator }}
        </span>
      </div>
      <div class="email">
        <span class="email-text">
          {{ email }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import defaultImage from '../assets/images/default.png';

export default {
  name: 'User',
  props: {
    discord: {
      type: Object,
      required: true
    },
    email: {
      type: String
    }
  },
  data() {
    return {
      defaultImage
    }
  },
  methods: {
    getImage: function() {
      return `https://cdn.discordapp.com/avatars/${this.discord.id}/${this.discord.avatar}.png`
    },
    useDefaultImage: function(e) {
      e.target.src = defaultImage;
    }
  }
}
</script>

<style scoped>
  .user-container {
    height: 200px;
    width: 400px;
    background-color: #282b2f;
    border-radius: 8px;
    color: #f8f8f8;
    margin: 0 auto;
    padding-top: 5px;
    box-shadow: 1px 1px 0px #2f3033,
                2px 2px 0px #282b2f,
                3px 3px 0px #2f3033,
                4px 4px 0px #282b2f,
                5px 5px 0px #2f3033,
                6px 6px 0px #282b2f;
  }

  .avatar-container {
    height: 80px;
    width: 80px;
    margin: 0 auto;
    margin-top: 25px;
  }

  .discord-avatar {
    max-height: 100%;
    max-width: 100%;
    border-radius: 75px;
  }
  
  .discord-tag {
    font-weight: 600;
    margin-top: 20px;
  }
</style>